import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * 旧路由保链：设计模板预览页已迁入建站工具。
 * /design-templates/$id → /site-tools/references/$id
 */
export const Route = createFileRoute("/_protected/design-templates/$id")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/site-tools/references/$id",
      params: { id: params.id },
    });
  },
});
